import { __decorate } from "tslib";
import { attr, customElement, FASTElement, html, when } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/ChameleonElement';
import { SVG_CLOSE } from '@getgo/chameleon-icons';
import styles from './Chip.styles.scss';
const template = html `<button>
  <slot name="avatar"></slot>
  <chameleon-typography color="${(x) => x.getFontColor()}">
    <slot></slot>
  </chameleon-typography>
  ${when((x) => x.closable, () => html `<span class="close" @click=${(x) => x.close()}
      ><chameleon-svg>${SVG_CLOSE}</chameleon-svg></span
    >`)}
</button>`;
export const chipDefinition = { name: 'chameleon-chip', template, styles };
let ChipComponent = class ChipComponent extends ChameleonElementMixin(FASTElement) {
    getFontColor() {
        if (this.disabled) {
            return 'text-03';
        }
        else if (this.selected || this.error) {
            return 'text-04';
        }
        return 'text-01';
    }
    close() {
        this.$emit('close', null, { bubbles: false });
    }
};
__decorate([
    attr({ mode: 'boolean' })
], ChipComponent.prototype, "selected", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ChipComponent.prototype, "disabled", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ChipComponent.prototype, "error", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ChipComponent.prototype, "closable", void 0);
__decorate([
    attr
], ChipComponent.prototype, "size", void 0);
ChipComponent = __decorate([
    customElement(chipDefinition)
], ChipComponent);
export { ChipComponent };
